import axios from "axios";

const api = axios.create({ baseURL: "/api/parcel" });

export const fetchParcel = (getParams) => api.get('', {params: getParams});